import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { RemyndProductFilterTypes } from "../types";

const useStyles = makeStyles(theme => ({
  contentContainer: {
    "& > *": {
      padding: theme.spacing(2)
    }
  }
}));
interface Props {
  open: boolean;
  filter: RemyndProductFilterTypes;
  onSubmit: (filter: RemyndProductFilterTypes) => void;
  onClose: () => void;
}

const parseBooleanRadio = (input: string) =>
  input === "true" ? true : input === "false" ? false : undefined;
const formatBooleanRadio = (input?: boolean) =>
  input === undefined ? "" : input.toString();

const ListFilterDialog: React.FC<Props> = props => {
  const { open, filter, onSubmit, onClose } = props;
  const classes = useStyles();

  const [filterState, setFilterState] =
    useState<RemyndProductFilterTypes>(filter);
  const { active, highlighted, canceled } = filterState;

  const handleSubmit = () => {
    onSubmit(filterState);
  };

  const handleClose = () => {
    onClose();
    setFilterState(filter);
  };

  const handleChangeActive = (
    _: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    setFilterState({ ...filterState, active: parseBooleanRadio(value) });
  };
  const handleChangeHighlighted = (
    _: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    setFilterState({ ...filterState, highlighted: parseBooleanRadio(value) });
  };
  const handleChangeCanceled = (
    _: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    setFilterState({ ...filterState, canceled: parseBooleanRadio(value) });
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Filters</DialogTitle>
      <DialogContent dividers>
        <Grid container className={classes.contentContainer}>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Active</FormLabel>
              <RadioGroup
                row
                aria-label="position"
                name="active"
                value={formatBooleanRadio(active)}
                onChange={handleChangeActive}
              >
                <FormControlLabel
                  value=""
                  control={<Radio color="primary" />}
                  label="ทั้งหมด"
                />
                <FormControlLabel
                  value="true"
                  control={<Radio color="primary" />}
                  label={"Y"}
                />
                <FormControlLabel
                  value="false"
                  control={<Radio color="primary" />}
                  label={"N"}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Highlighted</FormLabel>
              <RadioGroup
                row
                aria-label="position"
                name="highlighted"
                value={formatBooleanRadio(highlighted)}
                onChange={handleChangeHighlighted}
              >
                <FormControlLabel
                  value=""
                  control={<Radio color="primary" />}
                  label="ทั้งหมด"
                />
                <FormControlLabel
                  value="true"
                  control={<Radio color="primary" />}
                  label={"Y"}
                />
                <FormControlLabel
                  value="false"
                  control={<Radio color="primary" />}
                  label={"N"}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Canceled</FormLabel>
              <RadioGroup
                row
                aria-label="position"
                name="canceled"
                value={formatBooleanRadio(canceled)}
                onChange={handleChangeCanceled}
              >
                <FormControlLabel
                  value=""
                  control={<Radio color="primary" />}
                  label="ทั้งหมด"
                />
                <FormControlLabel
                  value="true"
                  control={<Radio color="primary" />}
                  label={"Y"}
                />
                <FormControlLabel
                  value="false"
                  control={<Radio color="primary" />}
                  label={"N"}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary">
          Save Filter
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ListFilterDialog;
